import React, { useState } from "react";
import FacilitySectionMobile from "./FacilitySectionMobile";
import FacilitySectionDesktop from "./FacilitySectionDesktop";

const FacilitySection = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < 600
  );

  React.useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return isMobile ? <FacilitySectionMobile /> : <FacilitySectionDesktop />;
};

export default FacilitySection;
